export default __webpack_public_path__ + "static/SRUS YT25 - Especification Del Producto y Datos Técnicos-d2ccb4d73630f8624fffab85f9547361.pdf";